const TEALIUM_SDK_WINDOW_NAME = 'tealium_data2track';
const TEALIUM_CUSTOM_EVENT = 'gv:onTealiumEvent';

export { TEALIUM_CUSTOM_EVENT, TEALIUM_SDK_WINDOW_NAME };
//# sourceMappingURL=constants.js.map
